import { UsersFilterState } from '../components/types'

const USERS_PAGE_LABELS = {
  users: 'Users',
}

const ROLES = [
  {
    label: 'None',
    value: '',
  },
  {
    label: 'Account owner',
    value: 'Account owner',
  },
  {
    label: 'Admin user',
    value: 'Admin user',
  },
  {
    label: 'Operator user',
    value: 'Operator user',
  },
]

const filterInitialState: UsersFilterState = {
  email: '',
  roleName: '',
  organizationName: '',
  pageNum: 0,
  pageSize: 10,
  sort: 'organizationName',
  sortDirection: 'asc',
}

const FILTER_LABELS = {
  role: 'Role',
  organizationName: 'Organization Name',
  applyFilter: 'Apply Filter',
  resetFilter: 'Reset Filter',
  usersFilter: 'Users Filter',
  email: 'Email',
}

export { USERS_PAGE_LABELS, ROLES, FILTER_LABELS, filterInitialState }
